/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit EditRules/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import BackAction from './BackAction/index'
import Fixed from './Fixed/index'
import InstallmentValue from './InstallmentValue/index'
import MaxDiscount from './MaxDiscount/index'
import Percentage from './Percentage/index'
import React from 'react'
import Relative from './Relative/index'
import SaveAction from './SaveAction/index'
import Total from './Total/index'
import TysiaHorizDivider from 'DesignSystem/TysiaHorizDivider/index'
import TysiaIconRules from 'DesignSystem/Svgs/TysiaIconRules/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import Value from './Value/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function EditRules({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Send/Content/Sidebar/Content/EditRules"
  
}) {
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="EditRules.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-1-960CE': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--pb-2-960CE': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--pl-3-960CE': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-4-960CE': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="EditRules.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-5-960CE': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaIconRules
  viewPath={`${viewPath}/TysiaIconRules`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="tiny"
 textTransform="uppercase"
 text="Plan Rules"
/>
</div>
</div>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 marginBottom={0}
 marginTop={0}
 backgroundColor={dtColorsNeutral200}
/>
<div
  data-testid="EditRules.Vertical"
  data-view-path={viewPath}
 style={{'--pt-1-960CE': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-4-960CE': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-2-960CE': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-3-960CE': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--g-5-960CE': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="EditRules.Vertical:1"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 text="Minimum Downpayment"
/>
<div
  data-testid="EditRules.Horizontal:2"
  data-view-path={viewPath}
 style={{'--pt-1-960CE': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-2-960CE': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal2}`}
>
<Fixed
  viewPath={`${viewPath}/Fixed`}
/>
<Percentage
  viewPath={`${viewPath}/Percentage`}
/>
</div>
<Value
  viewPath={`${viewPath}/Value`}
/>
</div>
<div
  data-testid="EditRules.Vertical:2"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 text="Maximum installment length"
/>
<div
  data-testid="EditRules.Horizontal:3"
  data-view-path={viewPath}
 style={{'--pt-1-960CE': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-2-960CE': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal3}`}
>
<Total
  viewPath={`${viewPath}/Total`}
/>
<Relative
  viewPath={`${viewPath}/Relative`}
/>
</div>
<InstallmentValue
  viewPath={`${viewPath}/InstallmentValue`}
/>
</div>
<MaxDiscount
  viewPath={`${viewPath}/MaxDiscount`}
/>
<div
  data-testid="EditRules.Horizontal:4"
  data-view-path={viewPath}
 style={{'--g-5-960CE': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal4}`}
>
<BackAction
  viewPath={`${viewPath}/BackAction`}
/>
<SaveAction
  viewPath={`${viewPath}/SaveAction`}
/>
</div>
</div>
{children}
</React.Fragment>)
}